// extracted by mini-css-extract-plugin
module.exports = {"c1j8cjc2":"c1j8cjc2"};